module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Informações Cadastrais\n\t\t\t")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1), _vm._v(" "), (false) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-categoria"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Gerenciar Categoria\n\t\t\t")]), _vm._v(" "), (_vm.formData.id > 0) ? _c('TabelaDinamicaCategoria', {
    attrs: {
      "tabela": _vm.formData
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.boolExibir) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-colunas"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-columns"
  }), _vm._v(" Gerenciar Colunas\n\t\t\t")]), _vm._v(" "), (_vm.formData.id > 0) ? _c('TabelaDinamicaColuna', {
    attrs: {
      "tabela": _vm.formData
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a7cc100"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/tabela-dinamica/editar.vue
// module id = 1432
// module chunks = 44